import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import { InputSearch } from 'components/fields'
import { form } from 'helpers/decorators'
import { apiSearch } from 'helpers/decorators/api'
import { minLength } from 'utils/validation'

import styles from './search-all-form.styl'

const validate = ({ searchQuery = '' } = {}) => ({
  searchQuery: minLength(3)(searchQuery.trim())
})

@injectIntl
@apiSearch()
@form({
  form: 'searchAll',
  validate
})
class SearchAllForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    intl: PropTypes.object,
    search: PropTypes.object
  }

  render() {
    const { handleSubmit, onSubmit, intl, search } = this.props

    return (
      <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <InputSearch
          name="searchQuery"
          labelless
          isLoading={search.isLoading}
          placeholder={intl.formatMessage({
            id: 'label.search',
            defaultMessage: 'Search'
          })}
        />
      </form>
    )
  }
}

export default SearchAllForm
